import { render } from "./DashboardEventUpsert.vue?vue&type=template&id=f11f46c0"
import script from "./DashboardEventUpsert.vue?vue&type=script&lang=js"
export * from "./DashboardEventUpsert.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__